import { defineStore } from 'pinia';

export type TeavitusedStore = {
  teavitused: Array<string>;
  teavitusedSaadud: boolean;
};

export const useTeavitusedStore = defineStore('teavitusedStore', {
  state: () => {
    return {
      teavitused: new Array<string>(),
      teavitusedSaadud: false,
    } as TeavitusedStore;
  },
  persist: { storage: sessionStorage },
  actions: {
    satiTeavitused(dto: Array<string>) {
      this.teavitused = { ...dto };
      this.teavitusedSaadud = true;
    },
    eemaldaTeavitused() {
      this.teavitused = new Array<string>();
      this.teavitusedSaadud = false;
    }
  },
});
